import { Injectable, EventEmitter } from '@angular/core';
import { HttpService, IResponseLower } from '../../../shared/cardholders-core/services/http-service.service';
import { AppConfigsService } from '../../../config/app-configs.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UiHelperService } from 'ClientApp/app/shared/cardholders-core/services/ui-helper.service';
import { ISpreadTransactionListCards } from '../interfaces/ISpreadTransactionListCards.interface';
import {
    IGetTransactionsForSpreadingResult,
    IGetTransactionsForSpreadingResultList
} from '../interfaces/IGetTransactionsForSpreadingResult.interface';
import { SpreadTransactionListContent } from '../interfaces/IContents.interface';
import { ISpreadTransactionT } from '../../transactions/transaction-details/models/ISpreadTransaction';
import { ITransactionDataResponse } from '../../spread-transaction/interfaces/transaction-data-response.interface';
@Injectable()
export class SpreadTransactionListService {
    showLoader: EventEmitter<boolean> = new EventEmitter<boolean>();
    contents: SpreadTransactionListContent;
    cards: ISpreadTransactionListCards[];
    isWebView = false;
    next: string;
    constructor(
        private httpSvc: HttpService,
        private appConfigsService: AppConfigsService,
        private uiHelper: UiHelperService
    ) {}

    getContents(): Observable<IResponseLower<SpreadTransactionListContent>> {
        if (this.contents) {
            return new BehaviorSubject<IResponseLower<SpreadTransactionListContent>>({
                result: this.contents,
                returnCode: 0,
                rcDesc: '',
                correlationId: ''
            }).asObservable();
        }
        this.showLoader.emit(true);
        return this.httpSvc
            .getLower<any>(
                `${this.appConfigsService.appConfigs.apiUrl}/registered/spreadTransactionList/getContents`,
                null
            )
            .pipe(
                tap(res => {
                    this.contents = res.result;
                    this.showLoader.emit(false);
                })
            );
    }

    getCards(): Observable<IResponseLower<ISpreadTransactionListCards[]>> {
        this.showLoader.emit(true);
        return this.httpSvc
            .getLower<any>(
                `${this.appConfigsService.appConfigs.apiUrl}/registered/spreadTransactionList/getCards`,
                null
            )
            .pipe(
                tap(res => {
                    this.cards = res.result;
                    this.showLoader.emit(false);
                })
            );
    }

    getTransactionsForSpreading(cardIndex: number): Observable<IResponseLower<IGetTransactionsForSpreadingResultList>> {
        this.showLoader.emit(true);
        return this.httpSvc
            .postLower<any>(
                `${
                    this.appConfigsService.appConfigs.apiUrl
                }/registered/spreadTransactionList/getTransactionsForSpreading`,
                { CardIndex: cardIndex }
            )
            .pipe(
                tap((res: IResponseLower<IGetTransactionsForSpreadingResultList>) => {
                    if (res.result) {
                        if (res.result.getTransactionsForSpreadingResults) {
                            res.result.getTransactionsForSpreadingResults.forEach(
                                x => (x.originalAmount = Number(x.originalAmount))
                            );
                        }
                        this.showLoader.emit(false);
                    } else {
                        this.showLoader.emit(false);
                    }
                })
            );
    }

    StartLoader(): void {
        this.showLoader.emit(true);
    }

    EndLoader(): void {
        this.showLoader.emit(false);
    }
}
